import React from 'react';

import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import './styles/Charts.css';
import { OcurrencesEvolution } from './OcurrencesEvolution';
import { OcurrencesByDay } from './OcurrencesByDay';
import { OcurrencesByHour } from './OcurrencesByHour';

const Period = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <OcurrencesEvolution />
                <OcurrencesByDay />
            </div>
            <OcurrencesByHour />
        </>
    );
};

export default Period;
